import { styled } from "@mui/material/styles";
import { Box, Paper, Typography } from "@mui/material";
import Projects from "../components/Projects";
import SearchIcon from "@mui/icons-material/Search";
import {
  SearchIconWrapper,
  SearchStyles,
  StyledInputBase,
} from "../mui-styles/SearchStyles";
import { useState } from "react";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: "black",
}));

const Search = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "black",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export default function ProjectsPage() {
  const [keyword, setKeyword] = useState("");
  const [itemPerPage, setItemPerPage] = useState(6);

  const onKeywordSearchBar = (e) => {
    // console.log("onKeywordSearchBar (setKeyword state):", e.target.value);
    e.preventDefault();
    setKeyword(e.target.value);
  };

  const onLoadMoreBtn = () => {
    setItemPerPage((prevPage) => prevPage + 4);
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: "bold", fontSize: 30 }}>
        🚀 Project
      </Typography>
      {/* SEARCH BAR */}
      <Search elevation={0}>
        <Box sx={{ flexGrow: 1 }} />
        <SearchStyles>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ "aria-label": "search" }}
            type="text"
            value={keyword}
            onChange={onKeywordSearchBar}
          />
        </SearchStyles>
      </Search>

      <Item>
        <Projects
          keyword={keyword}
          itemPerPage={itemPerPage}
          onLoadMoreBtn={onLoadMoreBtn}
        />
      </Item>
    </Box>
  );
}
